export enum MessageTypeEnum {
    deleteDisabled, responseTimerEnabled, isPenalty, info,
    response, messageLengthsEnabled, image,
}

export enum PreselectType {
    none,
    weekdays,
    daily,
    permanent,
    weekends,
}

export enum CountType {
    none,
    hours,
    minutes, // 2
    items,
    times, //4
    pence,
    days,
    swots,
    slaps, //8
    mouthfuls,
    sips,
    pints,
    inches, // 12
    centimetres,
    words,
    videos,
    pictures,
    millimetres,
    members,
    owners,
    tasks,
    punishments,
    durationInMinutes, // duration in minutes for videos to find
    durationInHours, // duration in hours for videos to find
    durationInSeconds, // duration in seconds for videos to find
    miles,
    kilometres,
    metres,
}
export enum LockCountType {
    none,
    days,
    weeks,
    months,
}

export enum ControlType {
    none,
    exactly,
    minimum,
    maximum,
}

export enum AvailabilityType {
    daily,
    weekends,
    weekdays,
    specific,
    random,
}

export enum EventDay {
    monday, // 0
    tuesday, // 1
    wednesday, // 2
    thursday, // 3
    friday, // 4
    saturday, // 5 
    sunday, // 6
}

export enum JavascriptDay {
    sunday, // 0
    monday, // 1
    tuesday, // 2
    wednesday, // 3
    thursday, // 4
    friday, // 5
    saturday, // 6 
}

export enum LockTypes {
    duration,
    target,
}

export enum WeekendHandling {
    normal,
    /**
     * @deprecated this enum value should not be used
     */
    skip,
    easy,
    harsh
}

export enum ReportStyle {
    once, twice,
}

export enum PenaltyPointConversionType {
    penalties, increaseCheckoutTarget, decreaseBankBalance
}

export enum PendingUpdateType {
    add, remove, refresh, permRelease, permissionChange, proofRequest, refreshSettings, update, scheduleChange, createPreview, scheduleRemove, scheduleReschedule, scheduleItemUpdate, settingsItemUpdate
}

export enum TraceLevel {
    info, warning, error, fatal
}

export enum AuditActionTypes {
    Settings,
    Messages,
    Session,
    User,
    Template,
    Event,
    Permission,
    Penalty,
    Task,
    Position,
    DailyChecks,
    Request,
    Alert,
    Exception,
}

export enum ItemTypes {
    task,
    permission,
    event,
    position,
    /**
     * @deprecated this enum value should not be used
     */
    task_old,
    /**
     * @deprecated this enum value should not be used
     */
    trainingSet_old,
    penalty
}

export enum Categories {
    tasks,
    penalties,
    events,
    permissions,
    positions,
    general,
    summary,
    settings,
    today,
    profile,
    newItems,
}

export enum PenaltyType {
    task,
    bankChargeAmount,
    bankChargePercent,
    increaseTargetAmount,
    lines,
    acknowledgement,
    increaseVoteCount,
}

export enum EventType {
    standard,
    startOfDay,
    checkout,
}

export enum Strictness {
    normal, kind, harsh,
}

export enum ProofStatus {
    random,
    alwaysRequestProof,
    neverRequestProof,
}

export enum TaskType {
    standard,
    lines,
    acknowledgement,
    /**
     * @deprecated this enum value should not be used
     */
    alwaysRequestProof,
    /**
     * @deprecated this enum value should not be used
     */
    neverRequestProof,
    /// this is required to be able to find the cage task item to allow code paths to make the item permanent
    chastity,
    roulette,
    categoryPicker,
    weeklyNumericTarget,
}

export enum ProfileRole {
    None,
    Member,
    Owner,
    Switch,
}

export enum FilterProfileRole {
    None,
    Member,
    Owner,
    Switch,
    HouseSlave,
}

export enum RewardType {
    perk,
    transfer,
}

export enum AvailabilityDayType {
    AllDays, // traditionally any items set to isHome false
    BusyDays, // new meaning only on safe days
    FreeDays, // traditionally any items set to isHome true
}

export enum ItemEditorFilterTypes {
    All,
    FreeDayItems,
    AllDayItems,
    BusyDayItems,
    OptionsDefined,
    WeekdayItem,
    WeekendItem,
    SpecificDayItem,
    RandomDayItem,
    SystemWontSchedule,
    ItemVisible,
    ItemHidden,
    ItemDeleted,
    UsesItems,
    UsesNoItems,
    HasEventTrigger,
    PermanentlyApplied,
    RouletteUsed,
    IsToy,
    InheritedFromSystem,
    InheritedFromOwner,
    OverridedFromSystem,
    CustomItem,
    VoteItem,
    CapturesLockImage,
    NoProofRequests,
    AwaitingApproval,
    Unowned,
    IsFavourite,
    Owned,
    Clothes,
    Outfits,
    NotMonitored,
    RecentlyAdded,
}

export const getItemEditorFilterTypeDisplayString = (e: ItemEditorFilterTypes) => {
    switch (e) {
        case ItemEditorFilterTypes.All: return 'All';
        case ItemEditorFilterTypes.FreeDayItems: return 'Available on Free Days';
        case ItemEditorFilterTypes.AllDayItems: return 'Available on All Days';
        case ItemEditorFilterTypes.BusyDayItems: return 'Available on Only Busy Days';

        case ItemEditorFilterTypes.OptionsDefined: return 'Options Defined';

        case ItemEditorFilterTypes.PermanentlyApplied: return 'Permanently Applied';
        case ItemEditorFilterTypes.WeekdayItem: return 'Weekday Item';
        case ItemEditorFilterTypes.WeekendItem: return 'Weekend Item';
        case ItemEditorFilterTypes.SpecificDayItem: return 'Specific Day Item';
        case ItemEditorFilterTypes.RandomDayItem: return 'Random Day Item';

        case ItemEditorFilterTypes.SystemWontSchedule: return 'System Wont Schedule';

        case ItemEditorFilterTypes.ItemVisible: return 'Item Visible';
        case ItemEditorFilterTypes.ItemHidden: return 'Item Hidden';
        case ItemEditorFilterTypes.ItemDeleted: return 'Item Deleted';

        case ItemEditorFilterTypes.UsesItems: return 'Uses toys';
        case ItemEditorFilterTypes.UsesNoItems: return 'Uses no toys';
        case ItemEditorFilterTypes.IsToy: return 'Is a Toy';

        case ItemEditorFilterTypes.HasEventTrigger: return 'Stops on an Event';
        case ItemEditorFilterTypes.RouletteUsed: return 'Roulette Used for Options';

        case ItemEditorFilterTypes.InheritedFromOwner: return 'Owner Item';
        case ItemEditorFilterTypes.InheritedFromSystem: return 'System Item';
        case ItemEditorFilterTypes.OverridedFromSystem: return 'Overriden System Item';
        case ItemEditorFilterTypes.CustomItem: return 'User Defined Item';

        case ItemEditorFilterTypes.VoteItem: return 'Other Members Can Vote';
        case ItemEditorFilterTypes.CapturesLockImage: return 'Capture Lock Image on Start';
        case ItemEditorFilterTypes.NoProofRequests: return 'No Proof Requests Allowed';

        case ItemEditorFilterTypes.AwaitingApproval: return 'Is new and yet to be approved on session';
        case ItemEditorFilterTypes.Unowned: return 'Is an item to own and not yet owned';
        case ItemEditorFilterTypes.IsFavourite: return 'Has been marked a favourite item';
        case ItemEditorFilterTypes.Owned: return 'Is an item that is owned by the member';
        case ItemEditorFilterTypes.Clothes: return 'Are items of clothing to wear';
        case ItemEditorFilterTypes.Outfits: return 'A collection of clothing items';
        case ItemEditorFilterTypes.NotMonitored: return 'A collection tasks that can run in parallel';
        case ItemEditorFilterTypes.RecentlyAdded: return 'Recently created items';
    }
}

export const getAvailableFilterTypes = (type: ItemTypes): ItemEditorFilterTypes[] => {
    const coreItems = [
        ItemEditorFilterTypes.All,

        ItemEditorFilterTypes.ItemVisible,
        ItemEditorFilterTypes.ItemHidden,
        ItemEditorFilterTypes.ItemDeleted,
        ItemEditorFilterTypes.FreeDayItems,
        ItemEditorFilterTypes.AllDayItems,
        ItemEditorFilterTypes.BusyDayItems,

        ItemEditorFilterTypes.InheritedFromSystem,
        ItemEditorFilterTypes.OverridedFromSystem,
        ItemEditorFilterTypes.InheritedFromOwner,
        ItemEditorFilterTypes.CustomItem,
        ItemEditorFilterTypes.AwaitingApproval,
        ItemEditorFilterTypes.RecentlyAdded,
    ]
    switch (type) {
        case ItemTypes.task: return [
            ...coreItems,

            ItemEditorFilterTypes.OptionsDefined,

            ItemEditorFilterTypes.IsToy,
            ItemEditorFilterTypes.UsesItems,
            ItemEditorFilterTypes.UsesNoItems,

            ItemEditorFilterTypes.VoteItem,
            ItemEditorFilterTypes.CapturesLockImage,
            ItemEditorFilterTypes.NoProofRequests,
            ItemEditorFilterTypes.HasEventTrigger,

            ItemEditorFilterTypes.PermanentlyApplied,
            ItemEditorFilterTypes.WeekdayItem,
            ItemEditorFilterTypes.WeekendItem,
            ItemEditorFilterTypes.SpecificDayItem,

            ItemEditorFilterTypes.SystemWontSchedule,
            ItemEditorFilterTypes.RouletteUsed,

            ItemEditorFilterTypes.IsFavourite,
            ItemEditorFilterTypes.Unowned,

            ItemEditorFilterTypes.Outfits,
            ItemEditorFilterTypes.NotMonitored,
        ];
        case ItemTypes.permission: return [
            ...coreItems,

            ItemEditorFilterTypes.OptionsDefined,

            ItemEditorFilterTypes.WeekdayItem,
            ItemEditorFilterTypes.WeekendItem,
            ItemEditorFilterTypes.SpecificDayItem,
            ItemEditorFilterTypes.RandomDayItem,

            ItemEditorFilterTypes.NotMonitored,
        ];
        case ItemTypes.event: return [
            ...coreItems,
            ItemEditorFilterTypes.WeekdayItem,
            ItemEditorFilterTypes.WeekendItem,
            ItemEditorFilterTypes.SpecificDayItem,
            ItemEditorFilterTypes.RandomDayItem,
        ];
        case ItemTypes.position: return [
            ...coreItems,
        ];
        case ItemTypes.penalty: return [
            ...coreItems,


            ItemEditorFilterTypes.OptionsDefined,

            ItemEditorFilterTypes.VoteItem,
            ItemEditorFilterTypes.CapturesLockImage,
            ItemEditorFilterTypes.NoProofRequests,
            ItemEditorFilterTypes.UsesItems,
            ItemEditorFilterTypes.UsesNoItems,
            ItemEditorFilterTypes.RouletteUsed,

            ItemEditorFilterTypes.HasEventTrigger,
            ItemEditorFilterTypes.IsFavourite,
            ItemEditorFilterTypes.NotMonitored,
        ];
        default: return [];
    }
}

export enum OwnerType {
    unowned, virtual, owned, loaned,
}

export enum ConciseMode {
    none,
    nameOnly,
    noButtons,
    noInfo,
}

export enum HygieneBreak {
    none,
    daily,
    twiceWeekly,
    weekly,
    twiceMonthly,
    monthly,
}

export enum LovensePresetName {
    pulse,
    wave,
    fireworks,
    earthquake
}


export enum SettingsType { Appearance, Chastity, Reporting, Randomness, Discord, Proofs, Scheduling, SchedulingTasks, SchedulingPositions, Protect, Economics, Tasks, Penalties, Events, Permissions, Positions, Summary }
export enum SettingsSubType { None, New, Hidden, Favourite, Unowned, Owned, Clothes, Outfits }

export enum EditorTab {
    General,
    Availability,
    Toys,
    Roulette,
    Options,
    Voting,
    Settings,
    LinkedTasks,
}
